module.exports = {
    'maintenance-summary': 'Resumen de mantenimiento',
    'month': 'mes',
    'year': 'año',
    'last-uploaded': 'Último subido',
    'change-in-wells-since-last-month': 'Cambio en pozos desde el mes pasado',
    'change-in-asset-wells-since-last-month': 'Cambio en pozos para este activo desde el mes pasado',
    'no-well-invoiced': 'No pozo facturado',
    'no-maintenance-invoice-found': 'No se encontró ninguna factura de mantenimiento',
    'none': 'ninguna',
}